// Third-party
import React from 'react';
import classNames from 'classnames';

type Props = {
  className?: string;
};

const ErrorIcon = ({ className }: Props) => <i className={classNames('error-icon icon-error', className)} />;

export default ErrorIcon;
